import { useTranslation } from 'react-i18next';
import { setLanguage, getCurrentLanguage, AVAILABLE_LANGUAGES } from '../i18n';

/**
 * Finding 10 — the old dropdown listed BOTH languages at once, which users
 * read as a duplicated language selection. With exactly two languages the
 * bar now shows only the ACTIVE one; a single click switches to the other
 * (persisted to localStorage, reapplied on every boot). The deliberate
 * long-form choice also lives in Settings → Kalba.
 */
export default function LanguageSwitcher() {
  const { t } = useTranslation();
  const currentLang = getCurrentLanguage();
  const current = AVAILABLE_LANGUAGES.find(l => l.code === currentLang) ?? AVAILABLE_LANGUAGES[0];
  const next = AVAILABLE_LANGUAGES.find(l => l.code !== current.code) ?? AVAILABLE_LANGUAGES[0];

  return (
    <button
      className="flex items-center gap-1.5 px-2 py-1 text-sm text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
      onClick={() => setLanguage(next.code)}
      title={`${t('common.language')}: ${current.label} → ${next.label}`}
    >
      <span className="text-base">{current.flag}</span>
      <span className="hidden sm:inline text-xs">{current.code.toUpperCase()}</span>
    </button>
  );
}
